import { createRouter, createWebHistory } from 'vue-router';
import { ROUTE_NAMES, ROUTE_PATHS } from '@src/shared/constants/routes';

export const router = createRouter({
	// eslint-disable-next-line turbo/no-undeclared-env-vars -- Vite injects BASE_URL at build time
	history: createWebHistory(import.meta.env.BASE_URL),
	routes: [
		{
			name: ROUTE_NAMES.earn,
			component: () => import('@src/pages/EarnPage.vue'),
			path: ROUTE_PATHS.earn,
		},
		{
			name: ROUTE_NAMES.portfolio,
			component: () => import('@src/pages/PortfolioPage.vue'),
			path: ROUTE_PATHS.portfolio,
		},
		{
			name: ROUTE_NAMES.profile,
			component: () => import('@src/pages/ProfilePage.vue'),
			path: ROUTE_PATHS.profile,
		},
	],
});

router.beforeEach((to, from) => {
	if (to.query['ref']) {
		return true;
	}

	const referralCode = from.query['ref'];
	if (!referralCode) {
		return true;
	}

	return {
		path: to.path,
		query: { ...to.query, ref: referralCode },
		hash: to.hash,
		replace: true,
	};
});
